import { IEditableQuestion } from "../types"

export default function questionJoiner(questions: IEditableQuestion[]): string {
  let body = ''
  let currentGroup = null
  let devider = ''
  questions.forEach(element => {
    body += devider
    body += element.rawBody
    devider = element.group != currentGroup ? "\n===\n" : "\n---\n"
  })
  return body
}
